var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('input',{class:_vm.classObject,attrs:{"type":"checkbox"},domProps:{"checked":_vm.isOn}}),_c('label',{attrs:{"for":"Order Recieved"},on:{"click":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }